(function () {
  var form = document.querySelector('[data-mm-search]');
  if (!form) return;
  var input = form.querySelector('input[type="search"]');
  var clearBtn = form.querySelector('[data-mm-search-clear]');
  var results = document.getElementById('yhl-mm-results');
  var status = results.querySelector('.yhl-mm__results-status');
  var list = results.querySelector('.yhl-mm__results-list');
  var panel = form.closest('.yhl-mm__panel');
  var timer = null, controller = null, lastQuery = '';

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function imgUrl(p) {
    var u = p.featured_image && p.featured_image.url || p.image;
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function highlight(text, q) {
    var t = esc(text), i = t.toLowerCase().indexOf(q.toLowerCase());
    return i < 0 ? t : t.slice(0, i) + '<mark>' + t.slice(i, i + q.length) + '</mark>' + t.slice(i + q.length);
  }

  function relevant(text, q) {
    var t = String(text).toLowerCase(), ql = q.toLowerCase();
    if (t.indexOf(ql) > -1) return true;
    var pre = ql.slice(0, 2);
    return t.split(/[^a-z0-9]+/).some(function (w) { return w && w.indexOf(pre) === 0; });
  }

  function reset() {
    if (controller) controller.abort();
    results.hidden = true;
    list.innerHTML = '';
    status.textContent = '';
    panel.classList.remove('is-searching');
    clearBtn.hidden = true;
    lastQuery = '';
  }

  // Handles of the products in the shop menu, printed by yhl-mobile-menu.liquid. Shopify ranks the ₹1399 ad copies
  // and the Black Friday listings above the real products, and the title dedupe below keeps the first one it sees,
  // so the real product was being dropped. Menu products sort first, then the dedupe keeps them (CB-286).
  var menuHandles = {};
  try { (JSON.parse(document.getElementById('yhl-mm-handles').textContent) || []).forEach(function (h) { menuHandles[h] = true; }); } catch (e) {}
  function menuFirst(list) {
    return list.map(function (p, i) { return { p: p, i: i }; })
      .sort(function (a, b) { return (menuHandles[a.p.handle] ? 0 : 1) - (menuHandles[b.p.handle] ? 0 : 1) || a.i - b.i; })
      .map(function (x) { return x.p; });
  }

  function render(q, products, articles) {
    var seen = {}, html = '';
    articles = articles.filter(function (a) { return relevant(a.title + ' ' + (a.summary_html || ''), q); });
    products = menuFirst(products).filter(function (p) {
      if ((p.tags || []).indexOf('partner-referral') > -1) return false;
      // The ad landing copies carry no-prepaid-discount and no real product does (CB-286).
      if ((p.tags || []).indexOf('no-prepaid-discount') > -1) return false;
      // No pricing in the menu: the build-your-own products are titled "Buy 2 @ 2199" and their images show the
      // price, so they stay out of drawer search. The Bundles panel's "Any 2" / "Any 3" tiles still reach them.
      if ((p.tags || []).indexOf('easy-bundle') > -1) return false;
      if (!relevant([p.title, p.type, p.vendor].concat(p.tags || []).join(' '), q)) return false;
      var key = p.title.toLowerCase().replace(/^yourhappy(life)?\s*/, '').replace(/[^a-z0-9]+/g, ' ').trim();
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
    products.forEach(function (p) {
      var img = imgUrl(p);
      html += '<a href="' + esc(p.url) + '" class="yhl-mm__product">' +
        '<span class="yhl-mm__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="60" height="60">' : '') + '</span>' +
        '<span class="yhl-mm__ptext"><span class="yhl-mm__pname">' + highlight(p.title, q) + '</span>' +
        (p.available === false ? '<span class="yhl-mm__price"><span class="yhl-mm__badge yhl-mm__badge--muted">Sold out</span></span>' : '') +
        '</span>' +
        '<span class="yhl-mm__chev" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></span></a>';
    });
    var total = products.length + articles.length;
    if (!total) {
      status.textContent = 'No results';
      list.innerHTML = '<p class="yhl-mm__results-empty">Nothing found for “' + esc(q) + '”. Try “collagen”, “hair” or “sleep”.</p>';
    } else {
      status.textContent = total + (total === 1 ? ' result' : ' results');
      if (articles.length) {
        html += '<p class="yhl-mm__results-group">From the blog</p>';
        articles.forEach(function (a) {
          var img = a.image || '';
          var sum = (a.summary_html || '').replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim().slice(0, 80);
          html += '<a href="' + esc(a.url) + '" class="yhl-mm__product">' +
            '<span class="yhl-mm__thumb">' + (img ? '<img src="' + esc(img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="" loading="lazy" width="60" height="60">' : '') + '</span>' +
            '<span class="yhl-mm__ptext"><span class="yhl-mm__pname">' + highlight(a.title, q) + '</span>' + (sum ? '<span class="yhl-mm__sub">' + esc(sum) + '…</span>' : '') + '<span class="yhl-mm__price"><span class="yhl-mm__badge yhl-mm__badge--muted">Article</span></span></span>' +
            '<span class="yhl-mm__chev" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></span></a>';
        });
      }
      list.innerHTML = html + '<a href="' + form.action + '?q=' + encodeURIComponent(q) + '&type=product,article" class="yhl-mm__results-all">See all results for “' + esc(q) + '” →</a>';
    }
    results.hidden = false;
    panel.classList.add('is-searching');
  }

  function search(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    lastQuery = q;
    status.textContent = 'Searching…';
    results.hidden = false;
    panel.classList.add('is-searching');
    var url = form.action.replace(/\/?$/, '') + '/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,article&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,vendor,variants.title,tag,author';
    fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (q !== lastQuery) return;
        var res = (data.resources && data.resources.results) || {};
        render(q, res.products || [], (res.articles || []).slice(0, 4));
      })
      .catch(function (e) { if (e.name !== 'AbortError') { status.textContent = 'Search unavailable'; } });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearBtn.hidden = !q;
    clearTimeout(timer);
    if (q.length < 2) { reset(); clearBtn.hidden = !q; return; }
    timer = setTimeout(function () { search(q); }, 250);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && input.value) { e.preventDefault(); e.stopPropagation(); input.value = ''; reset(); }
  });
  clearBtn.addEventListener('click', function () { input.value = ''; reset(); input.focus(); });
  form.addEventListener('submit', function (e) { if (input.value.trim().length < 2) e.preventDefault(); });

  document.addEventListener('yhl:menu-closed', function () { input.value = ''; reset(); });
})();
